import {LogEvent} from '../events.js';

export class PreviewWatched extends LogEvent {
  /**
   * @param {Movie} movie
   */
  constructor(movie) {
    super();
    this.type = 'PreviewWatched';
    this.movie = movie;
    this.startTime = Date.now();
    this.endTime = NaN;
  }

  /**
   * @returns {this}
   */
  end() {
    this.endTime = Date.now();
    return this;
  }

  /**
   * @returns {import('../events').LogEventDTO}
   * @throws {Error} If the end time isn't set
   */
  getDTO() {
    if (!this.endTime) {
      throw new Error('Log: PreviewWatch event not received end');
    }
    const dto = super.getDTO();
    dto.amateurId = this.movie.user_id.toString();
    dto.itemId = this.movie.id.toString();
    dto.secs = Math.round((this.endTime - this.startTime) / 1000);
    return dto;
  }
}
